export const positions = [
  [-1, 1, 0],
  [1, -1, 0],
  [-1, -1, 0],
  [-1, 1, 0],
  [1, 1, 0],
  [1, -1, 0],
]
